import InputLabel, {
  InputLabelCheckBox,
  InputLabelSelect,
} from "../../components/inputLabel";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import preCadastroActions from "../../redux/preCadastro/actions";
import { StoreState } from "../../redux/reduxTypes";
import { PreCadastroState } from "../../types/state.types";
import { DivisoriaSecao, TituloSecao } from "./styled";

function DadosCooperativismoPreCadastro() {
  const dispatch = useDispatch();

  const { dados, dadosIniciais } = useSelector<StoreState, PreCadastroState>(
    (state) => state.preCadastroState
  );

  const atualizarDadosPreCadastro = useCallback(
    (dadosForm: object) => {
      dispatch(
        preCadastroActions.setDados({
          ...dados,
          ...dadosForm,
        })
      );
    },
    [dados, dispatch]
  );

  return (
    <DivisoriaSecao>
      <TituloSecao>Dados de Cooperativismo</TituloSecao>

      <InputLabelSelect
        labelText="Conselho"
        labelId="conselhoID"
        value={dados.conselhoID}
        onChange={(value) => {
          atualizarDadosPreCadastro({ conselhoID: Number(value) });
        }}
        required
        options={
          dadosIniciais
            ? dadosIniciais.ListaConselho.map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabel
        labelText="Número do Conselho"
        labelId="numeroConselho"
        type="text"
        value={dados.numeroConselho}
        onChange={(value) => {
          atualizarDadosPreCadastro({ numeroConselho: value });
        }}
        required
        column
        maxLength={25}
      />

      <InputLabelSelect
        labelText="Categoria"
        labelId="categoriaID"
        value={dados.categoriaID}
        onChange={(value) => {
          atualizarDadosPreCadastro({ categoriaID: Number(value) });
        }}
        required
        options={
          dadosIniciais
            ? dadosIniciais.ListaCategoria.map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabelSelect
        labelText="Especialidade"
        labelId="especialidadeID"
        value={dados.especialidadeID}
        onChange={(value) => {
          atualizarDadosPreCadastro({ especialidadeID: Number(value) });
        }}
        options={
          dadosIniciais
            ? dadosIniciais.ListaEspecialidade.map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabelCheckBox
        labelText="Possui curso de Cooperativismo?"
        labelId="cursoCooperativismo"
        checked={dados.cursoCooperativismo}
        onChange={(value) => {
          atualizarDadosPreCadastro({ cursoCooperativismo: value });
        }}
        column
      />
    </DivisoriaSecao>
  );
}

export default DadosCooperativismoPreCadastro;
